import React, { Component } from 'react';
import {
  Row,
  Col,
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Popover,
  PopoverBody
} from 'reactstrap';


import InformationSVG from '../../assets/information.svg';

import { generateGUID  } from '../../utils';


class CheckboxInput extends Component {
  constructor(){
    super();

    this.state = {
      randomId:generateGUID(),
      tooltipOpen:false,
      value:false
    };
  }

  componentWillMount(){
    if(this.props.checked){
      this.setState({value:this.props.checked});
    }

    if(this.props.defaultChecked){
      this.setState({value:this.props.defaultChecked});
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.checked !== this.props.checked){
      this.setState({value:nextProps.checked});
    }
  }

  handleClick(e){
    this.setState({value:e.target.checked});
    this.props.onClick(e);
  }

  render(){
    const {
      name,
      label,
      tooltip,
      onChange,
      onClick,
      defaultChecked
    } = this.props;

    const {
      randomId,
      tooltipOpen,
      value
    } = this.state;

    return (
      <FormGroup check>
        <Label check>
          <Input
            type='checkbox'
            name={name}
            disabled={this.props.disabled}
            onClick={(e) => this.handleClick(e)}
            checked={value}
          />
          &nbsp;{label}
          {tooltip && (
            <span>
              &nbsp;&nbsp;
              <img
                alt='Tooltip information'
                src={InformationSVG}
                id={`tooltip_${randomId}`}
                onMouseEnter={() => this.setState({tooltipOpen:true})}
                onMouseLeave={() => this.setState({tooltipOpen:false})}
              />
              <Popover
                className='TooltipPopover'
                isOpen={tooltipOpen}
                target={`tooltip_${randomId}`}
                placement='right'
              >
                <PopoverBody>{tooltip}</PopoverBody>
              </Popover>
            </span>
          )}
        </Label>
      </FormGroup>
    )
  }
}

CheckboxInput.defaultProps = {
  defaultChecked:false,
  disabled:false,
  onChange:() => {},
  onClick:() => {}
}

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/shared/components/CheckboxInput/index.js